export const PagePaths = {
  HOME: "/",
  POLL: "/poll",
  IMAGE_LAB: "/image-lab",
  EXPLAIN_LAB: "/explain-lab",
};